// Debounce utility function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

import { qs, qsAll } from '../utils/domHelpers.js';
import { stateManager } from '../utils/stateManager.js';
import { trapFocus, releaseFocus } from '../utils/focusManager.js';

export class Header {
  constructor(baseQueryEl) {
    this.baseQueryEl = baseQueryEl;
  }

  init() {
    this.initMenuToggle();
    this.initSearch();
    this.initCart();
  }

  initMenuToggle() {
    const menuToggle = qs('.menu__toggle', this.baseQueryEl);
    if (menuToggle) {
      menuToggle.setAttribute('tabindex', '0');
      menuToggle.setAttribute('aria-expanded', 'false');

      const toggleMenu = () => {
        document.body.classList.remove('search--previewed', 'cart--previewed');
        if (stateManager.getState() !== 'menu') {
          stateManager.setState('menu');
          document.body.classList.add('menu--open');
          menuToggle.setAttribute('aria-expanded', 'true');
          trapFocus([document.querySelector('header.header'), document.querySelector('.header__menu')]);
        } else {
          stateManager.setState(null);
          document.body.classList.remove('menu--open');
          menuToggle.setAttribute('aria-expanded', 'false');
          releaseFocus();
        }
      };

      menuToggle.addEventListener('click', toggleMenu);
      menuToggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleMenu();
        }
      });
    }
  }

  initSearch() {
    const searchButton = qs('.header__icon-search', this.baseQueryEl);
    const searchCloseButton = qs('.menu__toggle--search-close', this.baseQueryEl);
    const searchInput = qs('#modal__search_input', this.baseQueryEl);

    if (searchButton) {
      searchButton.setAttribute('tabindex', '0');
      searchButton.setAttribute('aria-expanded', 'false');
      searchButton.addEventListener('click', () => {
        document.body.classList.remove('menu--open', 'cart--previewed');
        if (stateManager.getState() !== 'search') {
          searchInput.focus();
          stateManager.setState('search');
          document.body.classList.add('search--previewed');
          searchButton.setAttribute('aria-expanded', 'true');
          if (searchInput) {
            setTimeout(function () {
              searchInput.focus();
            }, 300);
          }
          trapFocus([document.querySelector('header.header'), document.querySelector('.section-header')]);
        } else {
          searchInput.blur();
          stateManager.setState(null);
          document.body.classList.remove('search--previewed');
          searchButton.setAttribute('aria-expanded', 'false');
          releaseFocus();
        }
      });
      searchButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          searchButton.click();
        }
      });
    }

    if (searchInput) {
      searchInput.addEventListener(
        'input',
        debounce(() => {
          if (searchInput.value.length >= 14) {
            searchInput.classList.add('length--extended');
          } else {
            searchInput.classList.remove('length--extended');
          }
        }, 150)
      );
    }

    if (searchCloseButton) {
      searchCloseButton.addEventListener('click', () => {
        if (stateManager.getState() === 'search') {
          searchInput.blur();
          stateManager.setState(null);
          document.body.classList.remove('search--previewed');
          releaseFocus();
        }
      });
    }
  }

  initCart() {
    const cartButton = qs('.header__cart', this.baseQueryEl);
    if (cartButton) {
      cartButton.setAttribute('tabindex', '0');
      cartButton.setAttribute('aria-expanded', 'false');
      cartButton.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('menu--open', 'search--previewed');
        if (stateManager.getState() !== 'cart') {
          stateManager.setState('cart');
          document.body.classList.add('cart--previewed');
          cartButton.setAttribute('aria-expanded', 'true');
          setTimeout(function () {
            trapFocus([document.querySelector('.drawer__inner--cart'), document.querySelector('header.header')]);
          }, 500);
          // trapFocus([document.querySelector('.drawer__inner--cart')]);
        } else {
          stateManager.setState(null);
          document.body.classList.remove('cart--previewed');
          cartButton.setAttribute('aria-expanded', 'false');
          releaseFocus();
        }
      });
      cartButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          cartButton.click();
        }
      });
    }

    // Delegate event for closing the cart.
    document.body.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.header__cart--close');
      if (closeBtn && stateManager.getState() === 'cart') {
        stateManager.setState(null);
        document.body.classList.remove('cart--previewed');
        releaseFocus();
      }
    });
  }
}
